module.exports = __webpack_public_path__ + "static/img/14areaA_1.0bd17da.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/14areaA_1.png
// module id = 1007
// module chunks = 1